import React from 'react';
import { Autocomplete, TextField, CircularProgress, Box, Typography } from '@mui/material';
import { AutocompleteProps } from '@mui/material/Autocomplete';

interface CustomAutocompleteProps<T> extends Omit<AutocompleteProps<T, false, false, false>, 'renderInput'> {
  label: string;
  placeholder?: string;
  loading?: boolean;
  error?: boolean;
  helperText?: string;
  fullWidth?: boolean;
  noOptionsText?: string;
  loadingText?: string;
  getOptionLabel?: (option: T) => string;
  isOptionEqualToValue?: (option: T, value: T) => boolean;
}

const CustomAutocomplete = <T,>({
  label,
  placeholder,
  loading = false,
  error = false,
  helperText,
  fullWidth = true,
  noOptionsText = "ไม่พบข้อมูล",
  loadingText = "กำลังค้นหา...",
  getOptionLabel,
  isOptionEqualToValue,
  ...props
}: CustomAutocompleteProps<T>) => {
  return (
    <Box >
      <Typography variant="body2" sx={{ mb: 1, fontWeight: "medium" }}>
        {label}
      </Typography>
      <Autocomplete
        fullWidth={fullWidth}
        loading={loading}
        noOptionsText={noOptionsText}
        loadingText={loadingText}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={isOptionEqualToValue}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            error={error}
            helperText={helperText}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        {...props}
      />
    </Box>
  );
};

export default CustomAutocomplete; 